const buildModel = (Type, data, ...otherArgs) => data && new Type(data, ...otherArgs);

export default buildModel;